module.exports = __webpack_public_path__ + "img/animal_avatar-06.e31e1c83.png";